import React from 'react'
import * as numeral from 'numeral'

import { Journey } from '../types/journey-api-response'
import * as moment from 'moment-timezone'
import { Moment } from 'moment'
import { Tooltip } from 'antd'
import { getCalculatedStatus } from '../../../components/journey-builder/helpers/journey'
import { titleCase } from '../../../_utils/utils'
import { extractJourneyTrigger } from '../../../_utils/journeys'
import { DomainDto } from '../../../dtos/domain'
import { getDomainCurrencyCode } from '../../../_utils/domain'
import { StatsWell, StatItem } from '../../../components/details-view/stats-well/'
import { JourneyStatusBadge } from '../../../components/badges/journey-status-badge'

interface IProps {
    loading: boolean
    domain?: DomainDto
    journey: Journey
    stats: any
}

export class JourneyGenStatsRow extends React.PureComponent<IProps> {
    public render(): React.ReactNode {
        const trigger = extractJourneyTrigger(this.props.journey)
        const hasRevenueStats = (this.props.stats.purchases ?? 0) > 0
        const isDisabled = this.isViewDisabled()
        const statusText = getCalculatedStatus(this.props.journey)

        const items: StatItem[] = [
            // {
            //     key: 'status',
            //     type: 'custom',
            //     label: 'Status',
            //     neverDisabled: true,
            //     render: () => <span className={`status-${statusText.toLowerCase()}`}>{titleCase(statusText)}</span>,
            // },
            {
                key: 'entries',
                type: 'numeric',
                label: 'Entries',
                value: this.props.stats.entrances || 0,
                animated: true,
            },
            {
                key: 'impressions',
                type: 'numeric',
                label: 'Impressions',
                value: this.props.stats.impressions ?? 0,
                disabled: isDisabled,
                animated: true,
            },
            {
                key: 'clicks',
                type: 'numeric',
                label: 'Clicks (CTR)',
                value: this.props.stats.clicks ?? 0,
                subValue: this.props.stats.ctr_decimal,
                subValueFormat: 'percent',
                disabled: isDisabled,
                animated: true,
            },
            {
                key: 'purchases',
                type: 'numeric',
                label: 'Purchases',
                value: this.props.stats.purchases ?? 0,
                disabled: isDisabled,
                hidden: !hasRevenueStats,
                animated: true,
            },
            {
                key: 'revenue',
                label: 'Revenue',
                value: this.formatRevenue(),
                disabled: isDisabled,
                hidden: !hasRevenueStats,
            },
        ]

        return (
            <div className="gen-stats-wrapper">
                <StatsWell loading={this.props.loading} items={items} variant="cards" />
                {/*<div className="gen-stats-row">*/}
                {/*    <div className="gen-stat">*/}
                {/*        <Well*/}
                {/*            className="thin gen-stats-well"*/}
                {/*            loading={this.props.loading}*/}
                {/*            hideHeader={true}*/}
                {/*            hideFooter={true}*/}
                {/*        >*/}
                {/*            <div className="chart-title">Entries</div>*/}
                {/*            <div className="stat stat-subs-total">{this.renderTotalSubsEntered()}</div>*/}
                {/*        </Well>*/}
                {/*    </div>*/}
                {/*    <div className="gen-stat">*/}
                {/*        <Well*/}
                {/*            className="thin gen-stats-well"*/}
                {/*            loading={this.props.loading}*/}
                {/*            hideHeader={true}*/}
                {/*            hideFooter={true}*/}
                {/*            disabled={this.isViewDisabled()}*/}
                {/*        >*/}
                {/*            <div className="chart-title">Impressions</div>*/}
                {/*            <div className="stat stat-impressions">{this.renderImpressions()}</div>*/}
                {/*        </Well>*/}
                {/*    </div>*/}
                {/*    <div className="gen-stat click-stats">*/}
                {/*        <Well*/}
                {/*            className="thin gen-stats-well"*/}
                {/*            loading={this.props.loading}*/}
                {/*            hideHeader={true}*/}
                {/*            hideFooter={true}*/}
                {/*            disabled={this.isViewDisabled()}*/}
                {/*        >*/}
                {/*            <Row gutter={24}>*/}
                {/*                <Col span={12}>*/}
                {/*                    <div className="chart-title">Clicks</div>*/}
                {/*                    <div className="stat stat-clicks">{this.renderClicks()}</div>*/}
                {/*                </Col>*/}
                {/*                <Col span={12}>*/}
                {/*                    <div className="chart-title">CTR</div>*/}
                {/*                    <div className="stat stat-ctr">{this.renderCTR()}</div>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Well>*/}
                {/*    </div>*/}
                {/*    {hasRevenueStats && (*/}
                {/*        <div className="gen-stat revenue-stats">*/}
                {/*            <Well*/}
                {/*                className="thin gen-stats-well"*/}
                {/*                loading={this.props.loading}*/}
                {/*                hideHeader={true}*/}
                {/*                hideFooter={true}*/}
                {/*                disabled={this.isViewDisabled()}*/}
                {/*            >*/}
                {/*                <Row gutter={24}>*/}
                {/*                    <Col span={12}>*/}
                {/*                        <div className="chart-title">Purchases</div>*/}
                {/*                        <div className="stat stat-purchases">{this.renderPurchases()}</div>*/}
                {/*                    </Col>*/}
                {/*                    <Col span={12}>*/}
                {/*                        <div className="chart-title">Revenue</div>*/}
                {/*                        <div className="stat stat-revenue">{this.renderRevenue()}</div>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*            </Well>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*</div>*/}
            </div>
        )
    }

    protected renderStatus(): React.ReactNode {
        const journey = this.props.journey
        const statusText = getCalculatedStatus(journey)

        return <JourneyStatusBadge status={statusText} expanded={true} />
    }

    protected renderTotalSubsEntered(): React.ReactNode {
        const entrances = this.props.stats.entrances || 0

        return entrances > 9999 ? (
            <Tooltip trigger="hover" title={numeral(entrances).format('0,0')}>
                {numeral(entrances).format('0,0.00a')}
            </Tooltip>
        ) : (
            numeral(entrances).format('0,0')
        )
    }

    private formatLargeNumber(value: number): string {
        if (!value && value !== 0) return '--'
        return value > 9999 ? numeral(value).format('0,0.00a') : numeral(value).format('0,0')
    }

    private formatRevenue(): string {
        const currency = getDomainCurrencyCode(this.props.domain)
        const amount = this.props.stats.purchase_amount
        return !amount ? '--' : Intl.NumberFormat('en-us', { style: 'currency', currency }).format(amount)
    }

    private isViewDisabled(): boolean {
        const isCancelled = this.props.journey.status === 'CANCELLED'
        const now: Moment = moment()
        const dateStart: Moment = moment(this.props.journey.date_start)
        const isScheduled = dateStart > now
        return isCancelled || isScheduled
    }
}
